export const galleryViewMap = {
  gallery: 'currentContactId',
  emailNudge: 'currentEmailNudge',
  suggestedBlock: 'currentSuggestBlockContact',
  cleanup: 'currentCleanup',
}
